module.exports = __webpack_public_path__ + "img/1497935209.b080b5ea.jpg";